<div class="header">
  <div class="name-container">
    <div class="name">{{ column().name }}</div>
    <div class="metadata--container">
      <div class="metadata--count">{{ metadata().totalResults ?? '-' }}</div>
    </div>
  </div>
  @if (columnAmounts() && (total().value || estimated().value)) {
    <div class="value">
      {{ total().value | glxyCurrency: total().currencyCode }}
      @if (estimated()?.value) {
        <mat-icon
          [matTooltip]="
            probability() +
            ('OPPORTUNITY.PIPELINE.PERCENTAGE_OF' | translate) +
            ' ' +
            (total().value | glxyCurrency: total().currencyCode)
          "
          >balance</mat-icon
        >
        {{ estimated().value | glxyCurrency: estimated().currencyCode }}
      }
    </div>
  }
</div>
